<template>
  <table-layout title="درس ها" :showSearch="false">

    <template #buttons>


      <router-link :to="{ name: 'TrashContents',params: { type: 'lesson' } }" class="ml-2">
        <b-button pill variant="danger">سطل زباله</b-button>
      </router-link>

      <router-link :to="{ name: 'CreateLessons' }" class="ml-2">
        <b-button pill variant="purple"> ساخت درس</b-button>
      </router-link>
      <LanguageSelectBox @changeLanguage="getItems" module-name="content" class="mx-4"/>


    </template>

    <template #table>
      <tableItems :items="lessons" :restoreState="false"/>
      <b-row class="pt-3 mt-3">
        <pagination :meta="paginationMeta" :on-change-page="changePage"/>
      </b-row>
    </template>
  </table-layout>
</template>

<script>
import TableLayout from "../../components/dashboard/TableLayout.vue";
import tableItems from "../../components/dashboard/Content/tableItemsForLesson";
import {mapGetters} from "vuex";
import Pagination from "../../components/dashboard/Pagination.vue";
import LanguageSelectBox from "../../components/dashboard/Language/LanguageSelectBox";


export default {
  name: "Lessons",
  components: {TableLayout, tableItems, Pagination, LanguageSelectBox},
  computed: {
    ...mapGetters({
      lessons: "Content/getContents",
      paginationMeta: "Content/getPaginationMeta",
    }),
  },
  methods: {
    changePage(page) {
      this.$store.dispatch("Content/getDashboardContents", {type: "lesson", page: page});
    },
    getItems() {
      this.$store.dispatch('Content/getDashboardContents', {type: "lesson", page: 1})
    }

  },
  mounted() {
    this.getItems();
  }
};
</script>